import { render, staticRenderFns } from "./assemble.vue?vue&type=template&id=064ce0dd&scoped=true&"
import script from "./assemble.vue?vue&type=script&lang=js&"
export * from "./assemble.vue?vue&type=script&lang=js&"
import style0 from "./assemble.vue?vue&type=style&index=0&id=064ce0dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ce0dd",
  null
  
)

export default component.exports